import React, { useRef, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, Loader2, Check } from "lucide-react";
import { toast } from "sonner";

export const UploadButton = ({ onUploaded, accept = "image/*,application/pdf", label = "Upload", variant = "outline", done = false }) => {
  const ref = useRef();
  const [loading, setLoading] = useState(false);

  const pick = () => ref.current?.click();
  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded(data);
      toast.success("File uploaded");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  return (
    <>
      <input ref={ref} type="file" accept={accept} onChange={handle} className="hidden" data-testid="file-input" />
      <Button type="button" variant={variant} size="sm" onClick={pick} disabled={loading} data-testid="upload-btn">
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : done ? <Check className="h-4 w-4 text-success" /> : <Upload className="h-4 w-4" />}
        <span className="ml-1.5">{label}</span>
      </Button>
    </>
  );
};
